import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import {
  Box,
  Button,
  FormLabel,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { useProyecto } from "../../../data/ProyectoContext";
import plusIcon from "../img/PlusIcon.svg";

const Problematica = () => {
  const { setProyecto } = useProyecto();
  const [agregarObjetivo, setAgregarObjetivo] = useState(false);
  const [nuevoObjetivo, setNuevoObjetivo] = useState("");
  const [objetivoManual, setObjetivoManual] = useState([]);

  //Funciones para manejar el comportamiento de conceptos clave
  const handleAgregarObjetivo = () => {
    setAgregarObjetivo(true);
  };

  const handleGuardarObjetivo = () => {
    if (nuevoObjetivo.trim() !== "") {
      setObjetivoManual((prevObjetivo) => [...prevObjetivo, nuevoObjetivo]);
      setNuevoObjetivo("");
      setAgregarObjetivo(false);
    }

    setProyecto((prevProyecto) => ({
      ...prevProyecto,
      problematicas: [...prevProyecto.problematicas, nuevoObjetivo],
    }));
  };

  const handleEliminarObjetivo = (index) => {
    // Actualiza el estado de los conceptos clave, eliminando el concepto clave seleccionado
    setObjetivoManual((prevObjetivo) =>
      prevObjetivo.filter((_, i) => i !== index)
    );
    setProyecto((prevProyecto) => ({
      ...prevProyecto,
      problematicas: prevProyecto.problematicas.filter((_, i) => i !== index),
    }));
  };

  return (
    <Grid item xs={12} mb={3}>
      <Typography
        sx={{
          color: "#336B87",
          fontFamily: "montserrat",
          fontSize: "1.25rem",
          fontWeight: "bold",
        }}
      >
        Problemáticas locales y contexto de la escuela
      </Typography>
      <FormLabel
        component="p"
        sx={{
          fontFamily: "montserrat",
          m: 0,
          pb: 2,
          fontSize: "0.85rem",
        }}
      >
        Proporciona información relevante sobre el contexto de la escuela que
        UmmIA debería tener en cuenta.
      </FormLabel>
      <Grid container>
        {agregarObjetivo ? (
          <>
            <TextField
              placeholder="Ejemplo: La escuela está situada en una área con escasez de agua"
              variant="outlined"
              fullWidth
              value={nuevoObjetivo}
              onChange={(e) => setNuevoObjetivo(e.target.value)}
              sx={{ fontFamily: "montserrat", mr: 2, mb: 2 }}
              InputProps={{
                sx: {
                  borderRadius: 2,
                  fontFamily: "montserrat",
                  fontSize: "0.75rem",
                  color: "#336B87",
                },
              }}
            />
            <Button
              sx={{
                backgroundColor: "#336B87",
                "&:hover": { backgroundColor: "#2B7C83" },
                fontFamily: "montserrat",
                fontWeight: "bold",
              }}
              variant="contained"
              onClick={handleGuardarObjetivo}
            >
              Guardar problemática
            </Button>
          </>
        ) : (
          <Grid item xs={12}>
            {objetivoManual.map((objetivo, index) => (
              <Box key={index} sx={{ display: "inline-block", m: 1 }}>
                <Button
                  variant="outlined"
                  onClick={() => handleEliminarObjetivo(index)}
                  sx={{
                    color: "#336B87",
                    fontFamily: "Montserrat",
                    fontWeight: "medium",
                    fontSize: "1.25rem",
                    borderColor: "rgba(51, 107, 135, 0.3)",
                    borderRadius: 50,
                    backgroundColor: "rgba(51, 107, 135, 0.3)",
                    textTransform: "none",
                    "&:hover": {
                      backgroundColor: "#FFF",
                      borderColor: "#336B87",
                    },
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "montserrat",
                      fontSize: "1.25rem",
                      display: "flex",
                      alignItems: "center",
                      color: "#336B87",
                      textTransform: "none",
                    }}
                  >
                    {objetivo}
                    <DeleteForeverIcon sx={{ ml: 1, color: "#336B87" }} />
                  </Typography>
                </Button>
              </Box>
            ))}
            <Button
              variant="outlined"
              sx={{
                fontFamily: "Montserrat",
                fontWeight: "medium",
                fontSize: "1.25rem",
                borderColor: "rgba(51, 107, 135, 0.3)",
                borderStyle: "dashed",
                borderRadius: 50,
                backgroundColor: "#FFF",
                boxShadow: 3,
                "&:hover": {
                  backgroundColor: "rgba(51, 107, 135, 0.3)",
                  boxShadow: 6,
                  borderColor: "rgba(51, 107, 135, 0.3)",
                  borderStyle: "dashed",
                },
                color: "#336B87",
                textTransform: "none",
              }}
              onClick={handleAgregarObjetivo}
            >
              <img
                src={plusIcon}
                alt="Icono"
                style={{ width: "25px", height: "25px" }}
              />
            </Button>
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};

export default Problematica;
